export default __webpack_public_path__ + "76c38ba2f814efd4ed9c30846494cfad.png";